<h4 translate>SJA_SCHEME</h4>

<div class="row">
  <!-- Left side Input fields-->
  <div class="left_side col-sm-6 section">
    <div class="form-group">
      <!-- SJA Title -->
      <label class="col-form-label">
        <span translate>SJA_TITLE</span>
        <span class="required">*</span>
      </label>
      <div class="input-btn-group">
        <p-select
          [filter]="true"
          [(ngModel)]="newSJAForm.SjaTitleId"
          [options]="editSJATitle"
          [style]="{ width: '100%' }"
          placeholder="{{ 'SELECT' | translate }}"
          [disabled]="!hasRights"
        >
          <ng-template let-sjaTitle pTemplate="item">{{
            sjaTitle.label | translate
          }}</ng-template>
        </p-select>
        <button
          class="btn btn-outline-primary"
          type="button"
          (click)="AddSJATitle()"
          [hidden]="!hasRights"
        >
          <i class="pi pi-plus" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <!-- Location -->
    <div class="form-group">
      <label class="col-form-label">
        <span translate>LOCATION</span>
      </label>
      <div>
        <input
          type="text"
          class="label-input form-control"
          [(ngModel)]="newSJAForm.Location"
          [disabled]="!hasRights"
        />
      </div>
    </div>
    <!-- Date -->
    <div class="form-group">
      <label class="col-form-label">
        <span translate>DATE</span>
      </label>
      <div>
        <p-datepicker
          [(ngModel)]="newSJAForm.Date"
          [showIcon]="true"
          [dateFormat]="'dd/mm/yy'"
          [readonlyInput]="true"
          [style]="{ width: '100%' }"
          [disabled]="!hasRights"
        ></p-datepicker>
      </div>
    </div>
    <!-- Participants -->
    <div class="form-group">
      <label class="col-form-label">
        <span translate>PARTICIPANTS</span>
      </label>
      <div>
        <input
          type="text"
          class="label-input form-control"
          [(ngModel)]="newSJAForm.Participants"
          [disabled]="!hasRights"
        />
      </div>
    </div>
    <!-- Responsible -->
    <div class="form-group">
      <label class="col-form-label">
        <span translate>SJA_RESPONSIBLE</span>
      </label>
      <div>
        <input
          type="text"
          class="label-input form-control"
          [(ngModel)]="newSJAForm.SjaResponsible"
          [disabled]="!hasRights"
        />
      </div>
    </div>
    <!-- Include checklist -->
    <div class="d-flex justify-content-between align-items-center form-group">
      <label class="col-form-label mb-0">
        <span translate>CHECK_FOR_COMPLETED_CHECKLIST</span>
      </label>
      <div class="custom-control custom-switch">
        <input
          type="checkbox"
          class="custom-control-input"
          id="checkCompletedChecklist"
          [(ngModel)]="newSJAForm.IsCheckCompletedChecklist"
          [disabled]="!hasRights"
        />
        <label
          class="custom-control-label"
          for="checkCompletedChecklist"
        ></label>
      </div>
    </div>
  </div>

  <!-- Right side Input fields-->
  <div class="right_side col-sm-6 section">
    <!-- Description -->
    <div class="form-group">
      <label class="col-form-label">
        <span translate>JOB_DESCRIPTION</span>
      </label>
      <div>
        <textarea
          class="form-control"
          [(ngModel)]="newSJAForm.JobDescription"
          [disabled]="!hasRights"
        ></textarea>
      </div>
    </div>
    <!-- Risk accociated with work -->
    <div class="form-group">
      <label class="col-form-label">
        <span translate>RISK_ASSOCIATED_WITH_WORK</span>
      </label>
      <div>
        <textarea
          class="form-control"
          [(ngModel)]="newSJAForm.RiskAssociatedWithWork"
          [disabled]="!hasRights"
        ></textarea>
      </div>
    </div>
    <!-- Protection security -->
    <div class="form-group">
      <label class="col-form-label">
        <span translate>PROTECTION_OR_SECURITY</span>
      </label>
      <div>
        <textarea
          class="form-control"
          [(ngModel)]="newSJAForm.ProtectionOrSecurity"
          [disabled]="!hasRights"
        ></textarea>
      </div>
    </div>
    <!-- Conclution / Comments -->
    <div class="form-group">
      <label class="col-form-label">
        <span translate>CONCLUSION_OR_COMMENTS</span>
      </label>
      <div>
        <textarea
          class="form-control"
          [(ngModel)]="newSJAForm.ConclusionOrComments"
          [disabled]="!hasRights"
        ></textarea>
      </div>
    </div>
  </div>
</div>
<h4 class="pt-2" translate>SIGNATURES</h4>

<div class="row section">
  <!-- Left side Signatue section -->
  <div class="left side signatures col-sm-6">
    <!-- SJA Responsible signature -->
    <div class="responsible_signature">
      <label class="col-form-label">
        <h5 translate>SJA_RESPONSIBLE</h5>
      </label>

      <span translate>ENTER_YOUR_SIGN</span>
      <div
        class="form-group signature-container"
        style="
          border: 1px solid #999999;
          position: relative;
          background-color: white;
          height: 100px;
        "
      >
        <canvas
          #canvas
          [style.pointer-events]="hasRights ? 'auto' : 'none'"
          style="width: 100%; height: 100%; display: block"
        >
        </canvas>
      </div>
      <div class="d-flex align-items-center mt-1">
        <button
          (click)="clearSign()"
          class="btn btn-outline-secondary mr-2"
          [hidden]="!hasRights"
        >
          <span translate>CLEAR_SIGN</span>
        </button>
        <span *ngIf="newSJAForm.DigitalResponsibleSign">
          <strong>{{ newSJAForm.DigitalResponsibleSign }}</strong>
        </span>
      </div>
    </div>

    <!-- Area manager -->
    <div class="area_manager pt-1">
      <label class="col-form-label">
        <h5 translate>AREA_MANAGER</h5>
      </label>
      <span translate>ENTER_YOUR_SIGN</span>
      <div
        class="form-group signature-container"
        style="
          border: 1px solid #999999;
          position: relative;
          background-color: white;
          height: 100px;
        "
      >
        <canvas
          #canvas1
          [style.pointer-events]="hasRights ? 'auto' : 'none'"
          style="width: 100%; height: 100%; display: block"
        >
        </canvas>
      </div>
      <div class="d-flex align-items-center mt-1">
        <button
          (click)="clearSign1()"
          class="btn btn-outline-secondary mr-2"
          [hidden]="!hasRights"
        >
          <span translate>CLEAR_SIGN</span>
        </button>
        <span *ngIf="newSJAForm.DigitalAreaManagerSign">
          <strong>{{ newSJAForm.DigitalAreaManagerSign }}</strong>
        </span>
      </div>
    </div>
  </div>
  <!-- Right side Signature section -->
  <div class="right_side col-sm-6">
    <!-- Responsible for execution -->
    <div class="resposible_for_execution">
      <!-- Responsible for execution -->
      <label class="col-form-label">
        <h5 translate>RESPONSIBLE_FOR_EXECUTION</h5>
      </label>

      <span translate>ENTER_YOUR_SIGN</span>
      <div
        class="form-group signature-container"
        style="
          border: 1px solid #999999;
          position: relative;
          background-color: white;
          height: 100px;
        "
      >
        <canvas
          #canvas2
          [style.pointer-events]="hasRights ? 'auto' : 'none'"
          style="width: 100%; height: 100%; display: block"
        >
        </canvas>
      </div>
      <div class="d-flex align-items-center mt-1">
        <button
          (click)="clearSign2()"
          class="btn btn-outline-secondary mr-2"
          [hidden]="!hasRights"
        >
          <span translate>CLEAR_SIGN</span>
        </button>
        <span *ngIf="newSJAForm.DigitalExecutionSign">
          <strong>{{ newSJAForm.DigitalExecutionSign }}</strong>
        </span>
      </div>
    </div>
    <!-- Other position -->
    <div class="other_position pt-1">
      <label class="col-form-label">
        <h5 translate>OTHER_POSITION</h5>
      </label>
      <span translate>ENTER_YOUR_SIGN</span>
      <div
        class="form-group signature-container"
        style="
          border: 1px solid #999999;
          position: relative;
          background-color: white;
          height: 100px;
        "
      >
        <canvas
          #canvas3
          [style.pointer-events]="hasRights ? 'auto' : 'none'"
          style="width: 100%; height: 100%; display: block"
        >
        </canvas>
      </div>
      <div class="d-flex align-items-center mt-1">
        <button
          (click)="clearSign3()"
          class="btn btn-outline-secondary mr-2"
          [hidden]="!hasRights"
        >
          <span translate>CLEAR_SIGN</span>
        </button>
        <span *ngIf="newSJAForm.DigitalOtherSign">
          <strong>{{ newSJAForm.DigitalOtherSign }}</strong>
        </span>
      </div>
    </div>
  </div>
</div>

<!-- Checklist section -->
<div *ngIf="newSJAForm.IsCheckCompletedChecklist">
  <h4 translate class="text-center pt-2">CHECKLIST</h4>
  <div class="row">
    <div class="col-sm-12 section">
      <div>
        <table class="table table-hover table-bordered SjaTable">
          <tbody>
            <tr style="background-color: #efefef">
              <th class="SjaChecklistHeading"></th>
              <th translate class="SjaChecklistHeading">HSC_ASPECT</th>
              <th translate class="SjaChecklistHeading">Yes</th>
              <th translate class="SjaChecklistHeading">No</th>
              <th translate class="SjaChecklistHeading">NOT_APPLICABLE</th>
              <th translate class="SjaChecklistHeading">
                COMMENTS_OR_MEASURES
              </th>
              <th translate class="SjaChecklistHeading">RESPO</th>
            </tr>

            <tr *ngFor="let item of SjaCheckList; let i = index">
              <td class="SjaRow text-right col-button" style="width: 8%">
                <button
                  *ngIf="item.IsParent && hasRights"
                  type="button"
                  (click)="addItem(item)"
                  title="Add Row" class="kuba-icon-btn kuba-icon-btn--primary kuba-icon-btn--row">
            <i class="pi pi-plus"></i>
          </button>
                <button
                  *ngIf="SjaCheckList.length > 1 && hasRights"
                  type="button"
                  class="btn btn-icon"
                  (click)="deleteItem(item, i)"
                  title="Delete Row"
                >
                  <span class="icon ic-sm icon-trash"></span>
                </button>
              </td>

              <td
                translate
                class="SjaRow"
                [ngClass]="{ parentField: item.IsParent }"
              >
                <input
                  type="text"
                  class="label-input form-control"
                  [(ngModel)]="item.Title"
                  [disabled]="!hasRights"
                />
              </td>
              <td class="SjaRow text-center" style="width: 4%; padding: 0">
                <input
                  *ngIf="!item.IsParent"
                  type="checkbox"
                  [(ngModel)]="item.Yes"
                  [disabled]="!hasRights"
                  (change)="uncheckExceptYes(item)"
                />
              </td>
              <td class="SjaRow text-center" style="width: 4%; padding: 0">
                <input
                  *ngIf="!item.IsParent"
                  type="checkbox"
                  [(ngModel)]="item.No"
                  [disabled]="!hasRights"
                  (change)="uncheckExceptNo(item)"
                />
              </td>
              <td class="SjaRow text-center" style="width: 4%; padding: 0">
                <input
                  *ngIf="!item.IsParent"
                  type="checkbox"
                  [(ngModel)]="item.NotApplicable"
                  [disabled]="!hasRights"
                  (change)="uncheckExceptNotApplicable(item)"
                />
              </td>
              <td class="SjaRow">
                <input
                  *ngIf="!item.IsParent"
                  type="text"
                  class="label-input form-control"
                  [(ngModel)]="item.Comments"
                  [disabled]="!hasRights"
                />
              </td>
              <td class="SjaRow">
                <input
                  *ngIf="!item.IsParent"
                  type="text"
                  class="label-input form-control"
                  [(ngModel)]="item.Respo"
                  [disabled]="!hasRights"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button
        type="button"
        class="btn btn-outline-success"
        (click)="addNewSection()"
        [hidden]="!hasRights"
      >
        <i class="pi pi-plus"></i>
        <span translate>NEW_SECTION</span>
      </button>
    </div>
  </div>
</div>

<!-- Checklist section ends -->
<!-- Buttons -->
<div class="action-btns-wrapper">
  <button type="button" class="btn btn-outline-secondary" (click)="gotoList()">
    <i class="pi pi-arrow-left"></i>
    <span translate>BACK_LIST</span>
  </button>
  <button
    *ngIf="hasRights"
    type="button"
    class="btn btn-primary"
    [disabled]="!newSJAForm.SjaTitleId || loading"
    (click)="onSaveClick()"
  >
    <span translate>SAVE</span>
  </button>
</div>

<!-- dialogs -->
<p-confirmDialog
  header="{{ 'CONFIRMATION' | translate }}"
  icon="pi pi-question-circle"
  width="425"
  acceptLabel="{{ 'SWITCH_YES' | translate }}"
  rejectLabel="{{ 'SWITCH_NO' | translate }}"
></p-confirmDialog>
<p-dialog
  header="{{ 'SJA_TITLE' | translate }}"
  [(visible)]="addTitle"
  [style]="{ width: '350px' }"
  [resizable]="false"
  [draggable]="false"
>
  <form [formGroup]="SJATitleForm">
    <div class="form-group">
      <label class="col-form-label">
        <span translate>SJA_TITLE</span>
        <span class="required">*</span>
      </label>
      <div>
        <input
          type="text"
          formControlName="SjaTitle"
          class="label-input form-control"
          required
        />
      </div>
      <label
        color
        class="col-form-label"
        *ngIf="isLabelDisabled"
        [ngStyle]="{ color: 'red' }"
      >
        <span translate>TOPIC_EXIST</span>
      </label>
      <label
        color
        class="col-form-label"
        *ngIf="isTitleAllocated"
        [ngStyle]="{ color: 'red' }"
      >
        <span translate>CANNOT_DELETE</span>
      </label>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
      <button
        type="button"
        class="btn btn-outline-primary"
        (click)="viewSJATitle = !viewSJATitle"
        (click)="BindSJATitle()"
      >
        <span translate>VIEW</span>
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="SJATitleForm.invalid"
        (click)="SaveTitle()"
      >
        <span translate>SAVE</span>
      </button>
    </div>
    <div *ngIf="viewSJATitle">
      <div class="table-view">
        <!-- Table starts -->
        <p-table
          #dt
          [value]="editSJATitle"
          [rows]="5"
          [paginator]="true"
          [pageLinks]="3"
          [rowsPerPageOptions]="[5, 10, 20]"
        >
          <!-- Header -->
          <ng-template pTemplate="header">
            <tr>
              <th>{{ "SJA_TITLE" | translate }}</th>
              <th></th>
            </tr>
            <tr>
              <th>
                <input
                  pInputText
                  type="text"
                  (input)="
                    dt.filter($any($event.target)?.value, 'label', 'contains')
                  "
                  placeholder=""
                  class="p-column-filter"
                />
              </th>
              <th></th>
            </tr>
          </ng-template>
          <!-- Body Content -->
          <ng-template pTemplate="body" let-sjaTitleData>
            <tr>
              <td>
                <span>{{ sjaTitleData.label }}</span>
              </td>
              <td class="col-button">
                <button
                  type="button"
                  title="{{ 'EDIT' | translate }}"
                  (click)="EditSJATitle(sjaTitleData)"
            [attr.aria-label]="'EDIT' | translate" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row">
            <i class="pi pi-pencil"></i>
          </button>
                <button
                  type="button"
                  title="{{ 'DELETE' | translate }}"
                  (click)="DeleteSJATitle(sjaTitleData)"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <!-- Table Ends -->
      </div>
    </div>
  </ng-template>
</p-dialog>
<!-- Loading bar -->
<p-progressBar
  mode="indeterminate"
  [style]="{ height: '6px' }"
  *ngIf="loading"
></p-progressBar>
